import '../../style/mobile/home/M_banner.scss';

const M_banner=()=>{
  return(
    <div className="M_banner">
      <div className="M_banner-text">
        <span>تا 40 درصدتخفیف استثنایی </span>
        ویژه عضویت یکساله آزمون مدرسه مصباح نور
      </div>
      <div className="M_banner-btn">مشاهده تعرفه‌ها</div>
    </div>
  )
}

export default M_banner;